import React, { PureComponent } from 'react'

import TextField from '@mui/material/TextField';

import theme from '../../theme'

// application components
import Typography from '@mui/material/Typography';
import Card from '../../components/Card/Card'
import CardTextElement from '../../components/Card/CardText'
import Sidebar, { SidebarItem, SidebarItemInput } from '../../components/Sidebar'
import Information from '../../components/Information/Information'
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import CustomizedSwitch from "../../../ui/components/CustomizedSwitch/CustomizedSwitch"

// application icons
import FilterIconSrc from '../../assets/img/icons/FilterIcon.svg'
import ThresholdSrc from '../../assets/img/icons/Schwellwert_CO2_Feuchte.svg'
import SlumberTimeSrc from '../../assets/img/icons/Schlummerzeit.svg'
import DeviceTimeSrc from '../../assets/img/icons/Datum_Uhrzeit.svg'
import SummerVentilationSrc from '../../assets/img/icons/Sommerlueftung.svg'
import log from 'loglevel'

import {t} from 'i18next'
import {Trans} from 'react-i18next'

// utils
import '../../../utils/elsc_utils'
import {
    KDtimeToDays,
    parseShortIsoDateTimeStringToKDdate,
    parseShortIsoDateTimeStringToKDtime,
    getBitValueFromByteArray,
    getBoolFromBoolString,
    getGatewayFirmwareVersionNumeric,
    isActualGwFirmwareVersionNewerThanOrEqualTargetVersion,

} from '../../../utils/elsc_utils'
import { useTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';

const styles = {
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        height: '100%',
    },
    cardWrapper: {
        display: 'flex',
        flexDirection: 'column',
        overflowX:'hidden',
        overflowY:"auto",
        height:'100%',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            flexDirection: 'column',
            overflowX:'hidden',
            overflowY:"auto"
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            overflowX:'hidden',
            overflowY:"auto"
        }
    },
    cardsTitle: {
        //position: 'absolute',
        marginTop: 20,
        marginBottom: 10,
        padding: '0 10px 10px 0',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '7px',
        },
    },
    cards: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingTop: theme.spacing.unit * 8,
        marginBottom:theme.dimensions.cardGap,
        paddingBottom:20,
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom:theme.dimensions.cardGap,
            paddingBottom:20,
        },
    },
    information: {
        margin: '20px 0',
        border: 'px solid red',
    },
    selectRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    inputStyle: {
        color: theme.palette.primary.dark,
        '&:after': {
            borderBottomColor: '#7F2D43'
          },
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
}

class Settings extends PureComponent {
    state = {
        activeCard: false,      // which card element is active
        sidebarOpen: false,     // sidebar flag
        sidebarChanged: false,  // data changing set
        selectedValue: '',      // value from select elements

        // for temporary updated values
        changedValues: {
            upTimeLimit: false,
            upTime: false,
            co2: false,
            humidity: false,
            slumberTime: false,
            summerVentilation: '',
            timeSynchEnabled: false,

        },
        rangeErrors: [],
        stepErrors: [],

        // card data
        filters: {
            upTimeLimit: this.props.settings.id_55 ? KDtimeToDays(this.props.settings.id_55) : 180,
            upTime: this.props.settings.id_167 ? KDtimeToDays(this.props.settings.id_167) : 180,
        },
        thresholds: {
            co2: {
                limit: this.props.settings.id_49 ? this.props.settings.id_49 : 1200,
                current: this.props.settings.id_172? this.props.settings.id_172 :1023,
            },
            humidity: {
                limit: this.props.settings.id_52 ? this.props.settings.id_52 : 75,
                current: this.props.settings.id_171 ? this.props.settings.id_171 : 52,
            },
        },
        slumberTime: this.props.settings.id_56 ? this.props.settings.id_56 : 90,
        devicesTime: {
            date: new Date(
                2018, 1, 1, 1
            ),
            time: '23:59',
        },
        timeSynchEnabled: this.props.gateWayData.time_sync_enable ? getBoolFromBoolString(this.props.gateWayData.time_sync_enable): true,
        timeSynchEnabledTransient: true,
        summerVentilation: this.props.settings.id_48? getBitValueFromByteArray(9, "string", this.props.settings.id_48): false,
        summerVentilationTransient: false,
        ranges: {
            upTimeLimit: [90, 270],
            co2: [100, 5000],
            humidity: [10, 95],
            slumberTime: [10, 250],
        },
        stepSizes: {
            upTimeLimit: 10,
            co2: 10,
            humidity: 1,
            slumberTime: 1,
        },
    }

    componentWillMount() {

    }

    componentDidMount() {
        log.debug("COMPONENT DID MOUNT!")
        this.setState({
            // ...this.state,
            summerVentilationTransient: this.getSummerVentilation(),
            timeSynchEnabledTransient: this.state.timeSynchEnabled
        })
        log.debug(this.state)
        log.debug(this.props)
    }

    componentDidUpdate() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        let change = false

         if(KDtimeToDays(nextProps.settings.id_55) !== KDtimeToDays( this.props.settings.id_55)){change=true}
         if(KDtimeToDays(nextProps.settings.id_167) !== KDtimeToDays(this.props.settings.id_167)){change=true}
         if(nextProps.settings.id_49 !== this.props.settings.id_49){change=true}
         if(nextProps.settings.id_172 !== this.props.settings.id_172){change=true}
         if(nextProps.settings.id_52 !== this.props.settings.id_52){change=true}
         if(nextProps.settings.id_171 !== this.props.settings.id_171){change=true}
         if(nextProps.settings.id_56 !== this.props.settings.id_56){change=true}
         if(nextProps.settings.id_48 !== this.props.settings.id_48){change=true}
        //  if(nextProps.settings.id_55 !== this.props.settings.id_55){count++}
        log.debug("componentWillReceiveProps", change, "Next Props: ",nextProps.settings,"Actual Props: ", this.props.settings, "Actual State: ", this.state)

        if(change){
            this.setState({
                ...this.state,
                filters: {
                   upTimeLimit: nextProps.settings.id_55 ? KDtimeToDays(nextProps.settings.id_55) : 180,
                   upTime: nextProps.settings.id_167 ? KDtimeToDays(nextProps.settings.id_167) : 180,
               },
               thresholds: {
                   co2: {
                       limit: nextProps.settings.id_49 ? nextProps.settings.id_49 : 1200,
                       current: nextProps.settings.id_172? nextProps.settings.id_172 :1023,
                   },
                   humidity: {
                       limit: nextProps.settings.id_52 ? nextProps.settings.id_52 : 75,
                       current: nextProps.settings.id_171 ? nextProps.settings.id_171 : 52,
                   },
               },
               slumberTime: nextProps.settings.id_56 ? nextProps.settings.id_56 : 90,

               timeSynchEnabled: nextProps.gateWayData.time_sync_enable ? getBoolFromBoolString(nextProps.gateWayData.time_sync_enable): true,

               summerVentilation: nextProps.settings.id_48? getBitValueFromByteArray(9, "string", nextProps.settings.id_48): false,


            })
        }

      }
    /**
     * set active card
     * @param activeCard
     */
    changeCard = activeCard => {
            this.setState({
                sidebarOpen: true,
                sidebarChanged: false,
                activeCard,
                rangeErrors: [],
                stepErrors: [],
                changedValues: {
                    upTimeLimit: false,
                    upTime: false,
                    co2: false,
                    humidity: false,
                    slumberTime: false,
                    summerVentilation: '',
                    timeSynchEnabled: false,
                    date: ''
                },
                summerVentilationTransient: this.getSummerVentilation(),
                timeSynchEnabledTransient: getBoolFromBoolString(this.props.gateWayData.time_sync_enable)
            })
            this.props.onMyLoad()
    }

    /**
     * closing sidebar
     */
    handleSidebarClose = () => {
        this.setState((prevState => ({
            activeCard: '',
            sidebarOpen: !prevState.sidebarOpen,
            sidebarChanged: false,
            changedValues: {
                upTimeLimit: false,
                upTime: false,
                co2: false,
                humidity: false,
                slumberTime: false,
                summerVentilation: '',
                timeSynchEnabled: false,
            },
        })))
        this.props.onMyLoad()
    }

    /**
     * get title depends on active card
     * @returns {boolean}
     */
    getSidebarTitle = () => {
        let title = ''
        switch (this.state.activeCard) {
            case 'filters':
                title = t('Settings.sidebar_title_filter')
                break
            case 'thresholds':
                title = t('Settings.sidebar_title_thresholds')
                break
            case 'slumberTime':
                title = t('Settings.sidebar_title_sleep')
                break
            case 'devicesTime':
                title = t('Settings.sidebar_title_devicetime')
                break
            case 'summerVentilation':
                title = t('Settings.sidebar_title_summerventilation')
                break
            default:
                break
        }
        return title
    }

    /**
     * saving the updated value
     */
    handleSidebarChange = () => {
        log.debug(this.state)
        Object.keys(this.state.changedValues).forEach(chValKey => {
            if (this.state.changedValues[chValKey]) {
                switch (chValKey) {
                    case 'upTimeLimit':
                    case 'upTime':
                        if (this.state.changedValues.upTime && this.state.changedValues.upTimeLimit) {
                            this.setState({
                                sidebarChanged: false,
                                filters: {
                                    ...this.state.filters,
                                    upTime: this.state.changedValues['upTimeLimit'],
                                    upTimeLimit: this.state.changedValues['upTimeLimit'],
                                },
                                changedValues: {
                                    ...this.state.changedValues,
                                    upTime: false,
                                    upTimeLimit: false,
                                },
                            })
                            this.props.onFilterParamsChange(this.state.changedValues['upTimeLimit'],this.state.changedValues['upTimeLimit'])

                        }
                        else {
                            this.setState({
                                sidebarChanged: false,
                                filters: {
                                    ...this.state.filters,
                                    [chValKey]: this.state.changedValues[chValKey]
                                },
                                changedValues: {
                                    ...this.state.changedValues,
                                    [chValKey]: false,
                                },
                            })
                            if (chValKey === 'upTimeLimit') {
                                this.props.onFilterMaxUptimeChange(this.state.changedValues[chValKey])
                            } else {
                                this.props.onFilterReset(this.state.filters.upTimeLimit)
                            }
                        }
                    break
                    case 'humidity':
                    case 'co2':
                        if (this.state.changedValues.co2 && this.state.changedValues.humidity) {
                            this.setState({
                                sidebarChanged: false,
                                thresholds: {
                                    ...this.state.thresholds,
                                    co2: {
                                        ...this.state.co2,
                                        limit: this.state.changedValues.co2,
                                    },
                                    humidity: {
                                        ...this.state.humidity,
                                        limit: this.state.changedValues.humidity,
                                    },
                                },
                                changedValues: {
                                    ...this.state.changedValues,
                                    co2: false,
                                    humidity: false,
                                },
                            })
                            this.props.onThresholdsChange(this.state.changedValues['co2'],this.state.changedValues['humidity'] )
                        } else {
                            this.setState({
                                sidebarChanged: false,
                                thresholds: {
                                    ...this.state.thresholds,
                                    [chValKey]: {
                                        ...this.state.thresholds[chValKey],
                                        limit: this.state.changedValues[chValKey],
                                    },
                                },
                                changedValues: {
                                    ...this.state.changedValues,
                                    [chValKey]: false,
                                },
                            })
                            if (chValKey === 'co2') {
                                this.props.onCoCoThresholdChange(this.state.changedValues['co2'])
                            } else {
                                this.props.onHumiThresholdChange(this.state.changedValues['humidity'])
                            }
                        }
                        break
                    case 'slumberTime':
                        this.setState({
                            sidebarChanged: false,
                            slumberTime: this.state.changedValues[chValKey],
                            changedValues: {
                                ...this.state.changedValues,
                                [chValKey]: this.state.changedValues[chValKey],
                            },
                        })
                        this.props.onSlumberTimeChange(this.state.changedValues[chValKey])
                        break
                    case 'summerVentilation':
                        this.setState(prevState => ({
                            sidebarChanged: false,
                            summerVentilation: !prevState.summerVentilation,
                            changedValues: { ...this.state.changedValues, [chValKey]: '' },
                        }))
                        let newVal = this.state.summerVentilationTransient
                        log.debug(newVal)
                        this.props.onSummerVentChange(newVal)
                        break
                    case 'timeSynchEnabled':
                        this.setState(prevState => ({
                            sidebarChanged: false,
                            timeSynchEnabled: !prevState.timeSynchEnabled,
                            changedValues: { ...this.state.changedValues, [chValKey]: false },
                        }))
                        let newValTs = this.state.timeSynchEnabledTransient
                        log.debug(newValTs)
                        this.props.onTimeSynchChange(newValTs)
                        break
                    default:
                        break
                }
            }
        })
    }

    /**
     * edit the temporary values
     * @param event
     * @param propname
     */
    handleSidebarInputChange = (event, propname) => {
        log.debug(event,propname)
        log.debug(event.target.value)
        // Validate for Ranges
        if (this.state.ranges[propname]) {
            if ((event.target.value < this.state.ranges[propname][0]) || (event.target.value > this.state.ranges[propname][1])) {
                if (!this.state.rangeErrors.includes(propname)) {
                    this.setState({
                        rangeErrors: [...this.state.rangeErrors, propname],
                    })
                }
            } else if (this.state.rangeErrors.includes(propname)) {
                const index = this.state.rangeErrors.indexOf(propname)
                this.setState({
                    rangeErrors: (0 === index) ? [] : [...this.state.rangeErrors.slice(0, index), ...this.state.rangeErrors.slice(index, +1)],
                })
            }
        }

        // Validate for right granularity of steps
        if (this.state.stepSizes[propname]) {
            if ((event.target.value % this.state.stepSizes[propname] !== 0))  {
                if (!this.state.stepErrors.includes(propname)) {
                    this.setState({
                        stepErrors: [...this.state.stepErrors, propname],
                    })
                }
            } else if (this.state.stepErrors.includes(propname)) {
                const index = this.state.stepErrors.indexOf(propname)
                this.setState({
                    stepErrors: (0 === index) ? [] : [...this.state.stepErrors.slice(0, index), ...this.state.stepErrors.slice(index, +1)],
                })
            }
        }

        // event.target.value ? (event.target.value=event.target.value) : (event.target.value=0)

        this.setState({
            sidebarChanged: true,
            changedValues: { ...this.state.changedValues, [propname]: event.target.value },
        })
    }

    /**
     * edit the temporary values
     */
    handleSummerVentilation = () => {
        this.setState({
            sidebarChanged: true,
            summerVentilationTransient: !this.state.summerVentilationTransient,
            changedValues: { ...this.state.changedValues, summerVentilation: true },
        })
    }

    handleTimeSynch = () => {
        this.setState({
            sidebarChanged: true,
            timeSynchEnabledTransient: !this.state.timeSynchEnabledTransient,
            changedValues: { ...this.state.changedValues, timeSynchEnabled: true },
        })
    }

    getDeviceTime = () => {
        return this.props.settings.id_2
    }

    getDeviceDate = () => {
        return this.props.settings.id_1
    }

    getSummerVentilation = () => {
        let helpString = this.props.settings.id_48
        let summerMask = 512
        let helpVal = parseInt(helpString, 16)
        if( helpVal & summerMask){
            return true
        }
        return false
    }

    getDeviceDateTimePickerFormatted = () => {
        let rawDate = this.props.settings.id_1
        let formattedDate = "20" + rawDate[6] + rawDate[7] + "-" + rawDate[3] + rawDate[4] + "-" + rawDate[0] + rawDate[1]
        log.debug(formattedDate + "T" + this.props.settings.id_2)
        let retVal = (formattedDate + "T" + this.props.settings.id_2.slice(0,5))
        return retVal
    }

    /**
     * returns date or time
     * @param type
     * @returns {boolean}
     */
    getCurrentDate = type => {
        const date = new Date()
        let dateTime = false

        switch (type) {
            case 'date':
                dateTime = `${ date.getDate()  }.${  (10 > (date.getMonth() + 1) ? `0${  date.getMonth() }` : date.getMonth()) }.${  date.getFullYear() }`
                break
            case 'time':
                dateTime = `${ (10 > date.getHours() ? `0${ date.getHours() }` : date.getHours()) }:${  (10 > date.getMinutes() ? `0${  date.getMinutes() }` : date.getMinutes()) }` + t('Settings.text_date_time')
                break
            default:
                break
        }

        return dateTime
    }

    getDateTime = () => {
        const date = new Date()
        log.debug(date.toISOString().slice(0,19))
        return date.toISOString().slice(0,19)
    }

    /**
     * set temporary date object for filters.upTimeLimit
     */
    handleFilterReset = () => {


        if(!!this.state.changedValues.upTime){
           if(!!this.state.changedValues.upTimeLimit){
            this.setState({
                changedValues: {
                    ...this.state.changedValues,
                    upTime:'',
                },
            })
           } else {
            this.setState({
                sidebarChanged: false,
                changedValues: {
                    ...this.state.changedValues,
                    upTime:'',
                },
            })
           }

        } else {
            this.setState({
                sidebarChanged: true,
                changedValues: {
                    ...this.state.changedValues,
                    upTime: this.state.filters.upTimeLimit,
                },
            })
        }

    }

    handleTimeSet = () => {
        log.debug(this.state.dateTimeString)

       let newDate = parseShortIsoDateTimeStringToKDdate(this.state.dateTimeString)
       let newTime = parseShortIsoDateTimeStringToKDtime(this.state.dateTimeString)

       this.props.onTimeDateChange(newDate, newTime)

    }

    render() {
        const { classes } = this.props
        log.debug(this.props)
        log.debug(this.state)
        log.debug(this.state.filters.upTimeLimit)
        return (

            <div style={styles.root}>
                <div style={styles.cardWrapper}>
                    <span style={styles.cardsTitle}>
                        <Typography variant="h5"><Trans i18nKey="Settings.heading"></Trans></Typography>
                    </span>

                    <Box style={styles.cards} rowGap={theme.dimensions.cardGap/7} columnGap={theme.dimensions.cardGap/7}>
                        <Card
                            label={t('Settings.card_label_filter')}
                            icon={<img src={FilterIconSrc} width={80} height={80} alt=''/>}
                            handleCardState={() => this.changeCard('filters')}
                            active={!(this.state.activeCard === 'filters' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Settings.card_text_filter_change_01')]}
                                content={[t('Settings.card_text_filter_change_02') + `${this.state.filters.upTime}` + t('Settings.card_text_filter_change_03')]} />
                            <CardTextElement label={[t('Settings.card_text_filter_runtime_01')]}
                                content={[`${this.state.filters.upTimeLimit}` + t('Settings.card_text_filter_runtime_02')]} />

                        </Card>

                        <Card
                            label={t('Settings.card_label_thresholds')}
                            icon={<img src={ThresholdSrc} width={80} height={80} alt='' />}
                            handleCardState={() => this.changeCard('thresholds')}
                            active={!(this.state.activeCard === 'thresholds' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Settings.card_text_thresholds_01')]}
                                content={[`${this.state.thresholds.co2.limit} ppm`]} />
                            <CardTextElement label={[t('Settings.card_text_thresholds_02')]}
                                content={[`${this.state.thresholds.humidity.limit} %`]} />
                        </Card>

                        <Card
                            label={t('Settings.card_label_sleep')}
                            icon={<img src={SlumberTimeSrc} width={80} height={80} alt=''/>}
                            handleCardState={() => this.changeCard('slumberTime')}
                            active={!(this.state.activeCard === 'slumberTime' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Settings.card_text_sleep_01')]}
                                content={[`${this.state.slumberTime}` + t('Settings.card_text_sleep_02')]} />
                        </Card>

                        <Card
                            label={t('Settings.card_label_devicetime')}
                            icon={<img src={DeviceTimeSrc} width={80} height={80} alt='' />}
                            handleCardState={() => this.changeCard('devicesTime')}
                            active={!(this.state.activeCard === 'devicesTime' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Settings.card_text_devicetime_01')]}
                                content={[this.getDeviceDate()]} />
                            <CardTextElement label={[t('Settings.card_text_devicetime_02')]}
                                content={[this.getDeviceTime().slice(0,5)]} />
                        </Card>

                        <Card
                            label={t('Settings.card_label_summerventilation')}
                            icon={<img src={SummerVentilationSrc} width={80} height={80} alt='' />}
                            handleCardState={() => this.changeCard('summerVentilation')}
                            active={!(this.state.activeCard === 'summerVentilation' || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement label={[t('Settings.card_text_summerventilation_state')]}
                                content={[(this.state.summerVentilation) ? t('Settings.card_text_summerventilation_active') : t('Settings.card_text_summerventilation_not_active')]} />
                            {(this.state.summerVentilation)
                                && (
                                    <CardTextElement label={[t('Settings.card_helperlabel_summerventilation')]}
                                        content={[t('Settings.card_helpertext_summerventilation')]} />
                                )}
                        </Card>
                    </Box>
                </div>

                <Sidebar title={this.getSidebarTitle()}
                    open={this.state.sidebarOpen}
                    changed=    {(0 === this.state.rangeErrors.length
                                && 0 === this.state.stepErrors.length) ? this.state.sidebarChanged : false}
                    closed={() => this.handleSidebarClose()}
                    handleSidebarChange={() => {
                        if ((0 === this.state.rangeErrors.length
                            && 0 === this.state.stepErrors.length)) { this.handleSidebarChange() }
                    }
                    }
                    error={!!(this.state.rangeErrors.length) || !!(this.state.stepErrors.length)}
                >
                    {(this.state.activeCard && this.state.sidebarOpen)
                        && (
                            <div>
                                {('filters' === this.state.activeCard)
                                    && (
                                        <div>
                                            <SidebarItem
                                                title={t('Settings.sidebar_item_title_filter')}
                                                subtitle={t('Settings.sidebar_item_subtitle_filter_01') +`${this.state.filters.upTime}` + t('Settings.sidebar_item_subtitle_filter_02')}
                                                divider
                                            >
                                                <CustomizedSwitch
                                                    checked={(!!this.state.changedValues.upTime)}
                                                    onChange={() => this.handleFilterReset()}
                                                />
                                            </SidebarItem>

                                            <SidebarItemInput
                                                propName={'upTimeLimit'}
                                                title={t('Settings.sidebar_item_input_title_filter')}
                                                subtitle={t('Settings.sidebar_item_input_subtitle_filter')}
                                                helperText={t('Settings.sidebar_item_input_helpertext_filter_01') +`${this.state.ranges.upTimeLimit[0]}` + t('Settings.sidebar_item_input_helpertext_filter_02') + `${this.state.ranges.upTimeLimit[1]}` + t('Settings.sidebar_item_input_helpertext_filter_03') + `${this.state.stepSizes.upTimeLimit}` + t('Settings.sidebar_item_input_helpertext_filter_04')}
                                              //  value={(!this.state.changedValues.upTimeLimit) ? this.state.filters.upTimeLimit : this.state.changedValues.upTimeLimit}
                                              //  value={(this.state.changedValues.upTimeLimit) ? this.state.changedValues.upTimeLimit : 0}
                                              value={(this.state.changedValues.upTimeLimit=== false ? this.state.filters.upTimeLimit : this.state.changedValues.upTimeLimit)}
                                              defaultValue ={this.state.filters.upTimeLimit}
                                                label={t('Settings.sidebar_item_input_label_filter')}
                                                handleChange={(event, propname) => {
                                                    this.handleSidebarInputChange(event, propname)}}
                                                valueRange={this.state.ranges.upTimeLimit}
                                                error={(this.state.rangeErrors.includes('upTimeLimit') || this.state.stepErrors.includes('upTimeLimit'))}
                                                step={10}
                                                textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                                            />

                                        </div>
                                    )}

                                {('thresholds' === this.state.activeCard)
                                    && (
                                        <div>
                                            <SidebarItemInput
                                                divider
                                                propName={'co2'}
                                                title={t('Settings.sidebar_item_title_thresholds_co2')}
                                                helperText={t('Settings.sidebar_item_helpertext_thresholds_co2_01') + `${this.state.ranges.co2[0]}`+ t('Settings.sidebar_item_helpertext_thresholds_co2_02') + `${this.state.ranges.co2[1]}` + t('Settings.sidebar_item_helpertext_thresholds_co2_03') +`${this.state.stepSizes.co2}` + t('Settings.sidebar_item_helpertext_thresholds_co2_04')}
                                                value={(this.state.changedValues.co2 === false) ? this.state.thresholds.co2.limit : this.state.changedValues.co2}
                                                defaultValue = {this.state.thresholds.co2.limit}
                                                label={t('Settings.sidebar_item_label_thresholds_co2')}
                                                handleChange={(event, propname) => this.handleSidebarInputChange(event, propname)}
                                                valueRange={this.state.ranges.co2}
                                                error={(this.state.rangeErrors.includes('co2') ||  this.state.stepErrors.includes('co2'))}
                                                step={10}
                                                textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                                            >
                                                <Information>
                                                    {t('Settings.sidebar_item_infotext_thresholds_co2_01') + `${this.state.thresholds.co2.current}` + t('Settings.sidebar_item_infotext_thresholds_co2_02')}
                                                </Information>
                                            </SidebarItemInput>
                                            <SidebarItemInput
                                                propName={'humidity'}
                                                title={t('Settings.sidebar_item_title_thresholds_humidity')}
                                                helperText={t('Settings.sidebar_item_helpertext_thresholds_humidity_01') + `${this.state.ranges.humidity[0]}` + t('Settings.sidebar_item_helpertext_thresholds_humidity_02') + `${this.state.ranges.humidity[1]}` + t('Settings.sidebar_item_helpertext_thresholds_humidity_03')}
                                                value={(this.state.changedValues.humidity === false) ? this.state.thresholds.humidity.limit : this.state.changedValues.humidity}
                                                defaultValue = {this.state.thresholds.humidity.limit}
                                                label={t('Settings.sidebar_item_label_thresholds_humidity')}
                                                handleChange={(event, propname) => this.handleSidebarInputChange(event, propname)}
                                                valueRange={this.state.ranges.humidity}
                                                error={(this.state.rangeErrors.includes('humidity') || this.state.stepErrors.includes('humidity'))}
                                                textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                                            >
                                                <Information>
                                                    {t('Settings.sidebar_item_infotext_thresholds_humidity_01') + `${this.state.thresholds.humidity.current}` + t('Settings.sidebar_item_infotext_thresholds_humidity_02')}
                                                </Information>
                                            </SidebarItemInput>
                                        </div>
                                    )}

                                {('slumberTime' === this.state.activeCard)
                                    && (
                                    <ThemeProvider theme={theme}>
                                        <SidebarItemInput
                                        //  classes={{underline: classes.inputStyle}}
                                            hiddeTitle
                                            propName={'slumberTime'}
                                            title={t('Settings.sidebar_item_title_sleep')}
                                            helperText={t('Settings.sidebar_item_helpertext_sleep_01') + `${this.state.ranges.slumberTime[0]}` +t('Settings.sidebar_item_helpertext_sleep_02') + `${this.state.ranges.slumberTime[1]}` + t('Settings.sidebar_item_helpertext_sleep_03')}
                                            value={(this.state.changedValues.slumberTime === false) ? this.state.slumberTime : this.state.changedValues.slumberTime}
                                            label={t('Settings.sidebar_item_label_sleep')}
                                            handleChange={(event, propname) => this.handleSidebarInputChange(event, propname)}
                                            valueRange={this.state.ranges.slumberTime}
                                            error={(this.state.rangeErrors.includes('slumberTime') || this.state.stepErrors.includes('slumberTime'))}
                                            textFieldUnerline={styles.textFieldUnerline}
                                                textFieldFormLabel={styles.textFieldFormLabel}
                                                textFieldFocused={styles.textFieldFocused}
                                        />
                                     </ThemeProvider> 
                                    )}

                            {('summerVentilation' === this.state.activeCard)
                                && (

                                    <SidebarItem>
                                        <div>
                                            {/* <Typography variant={'subheading'}>Status</Typography> */}
                                            <div style={styles.selectRow}>
                                                <Typography variant={'caption'} style={{ marginBottom: 0 }}>
                                                    {(this.state.summerVentilationTransient) ? t('Settings.sidebar_item_title_summerventilation_active') : t('Settings.sidebar_item_title_summerventilation_inactive')}
                                                </Typography>
                                                <CustomizedSwitch
                                                    checked={(this.state.summerVentilationTransient)}
                                                    onChange={() => this.handleSummerVentilation()}
                                                />
                                            </div>
                                            {(this.state.summerVentilationTransient)
                                                && (
                                                    <Information>
                                                        <Trans i18nKey="Settings.sidebar_item_helpertext_summerventilation"></Trans>
                                                    </Information>
                                                )}
                                        </div>
                                    </SidebarItem>

                                )}
                                {('devicesTime' === this.state.activeCard)
                                    &&
                                    (<div>
                                        <SidebarItem>
                                            <div>
                                                <div style={styles.selectRow}>

                                                    <Typography variant={'caption'} style={{ marginBottom: 0 }}>
                                                        {/* {(this.state.timeSynchEnabledTransient) ? 'Automatische Synchronisierung ist aktiviert' : 'Automatische Synchronisierung ist deaktiviert'} */}
                                                {isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) &&
                                                   ( (this.state.timeSynchEnabledTransient) ? t('Settings.sidebar_item_devicetime_switch_active') : t('Settings.sidebar_item_devicetime_switch_inactive'))}
                                                   {!isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) &&
                                                   ( t('Settings.sidebar_item_devicetime_switch_disabled'))}
                                                    </Typography>
                                                    <CustomizedSwitch

                                                        checked={isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) ? (this.state.timeSynchEnabledTransient) : (false)}
                                                        onChange={isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) ? () => this.handleTimeSynch(): false }
                                                    />
                                                </div>
                                                {(isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")))
                                                    &&
                                                    (this.state.timeSynchEnabledTransient)
                                                    && (
                                                        <Information>
                                                           <Trans i18nKey="Settings.sidebar_item_devicetime_infotext"></Trans>
                                                        </Information>
                                                    )}
                                            </div>
                                        </SidebarItem>
                                        <SidebarItem>
                                            <form style={{...styles.container, width:"100%"}} noValidate>
                                             <ThemeProvider theme={theme}>
                                                <TextField
                                                    InputProps={{
                                                        styles: {
                                                            underline: styles.textFieldUnerline
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        FormLabelClasses: {
                                                            root: styles.textFieldFormLabel,
                                                            focused: styles.textFieldFocused,
                                                        },
                                                    }}
                                                    // disabled= {true}
                                                    id="datetime-local"
                                                    disabled={(isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0"))) ? ( this.state.timeSynchEnabledTransient ? true : false) : true}
                                                    label={t('Settings.sidebar_item_devicetime_label')}
                                                    type="datetime-local"
                                                    variant={'standard'}
                                                    defaultValue={this.getDeviceDateTimePickerFormatted()}
                                                    style={{...styles.textField, width:"100%"}}
                                                    // InputLabelProps={{
                                                    // }}
                                                    onChange={
                                                        isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) ?
                                                        ((e) => {
                                                        this.setState({ dateTimeString: e.target.value })
                                                        log.debug(e.target.value)
                                                        }) :
                                                        false
                                                    }
                                                />
                                            </ThemeProvider> 
                                            </form>
                                            <Button
                                                disabled={ (isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0"))) ?   ( this.state.dateTimeString ? false : true) : true}
                                                // disabled = {true}
                                                // color='primary'
                                                variant={"outlined"}
                                                onClick={isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0")) ? () => this.handleTimeSet(): false }
                                                style={this.state.dateTimeString ? { color: theme.palette.primary.dark, padding: 0 } : { padding: 0 }}
                                                sx={{marginTop:4}}
                                            >
                                                <Trans i18nKey="Settings.sidebar_item_devicetime_button_submit"></Trans>
                                        </Button>
                                                    {(!isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(getGatewayFirmwareVersionNumeric(this.props.gateWayData.fw_version),
                                                    getGatewayFirmwareVersionNumeric("2.1.0"))) &&

                                                    (<Information>
                                                        <Trans i18nKey="Settings.sidebar_item_devicetime_firmwareupdate_infotext"></Trans>
                                                        </Information>)
                                                 }
                                        </SidebarItem>
                                    </div>)
                                }
                            </div>
                        )}
                </Sidebar>
            </div>
        )
    }
}

export default Settings
